export const F2UpsellHeapId = 'F2_Upsell'
export const F2UpsellHubspotEvent = 'pe8765124_f2_upsell_get_demo_clicked'
